require('normalize.css');
require('styles/App.css');

import React from 'react';

import ResultsComponent from './search/ResultsComponent'
import NavBarComponent from './nav/BarComponent'
import FooterComponent from './FooterComponent'

var serverLocation = "http://api.metadroner.com:3000"

class AppComponent extends React.Component {
  constructor(props) {
      super(props);
      this.state = {
          searchTerm : "",
          isSearching: false,
          productData: []
      };
      this.setSearchTerm = this.setSearchTerm.bind(this);
  }

  componentWillMount() {
      document.body.style.backgroundColor = "black";
  }

  componentWillUnmount() {
      document.body.style.backgroundColor = null;
  }

  setSearchTerm(searchTerm, searchStore, searchCountry, searchStock, searchCategory, searchSort) {
    if (searchTerm == "" || this.state.isSearching == true) {
      return
    }
    if (searchTerm == this.state.searchTerm &&
      searchTerm == this.state.searchTerm &&
      searchStore == this.state.searchStore &&
      searchCountry == this.state.searchCountry &&
      searchCategory == this.state.searchCategory &&
      searchSort == this.state.searchSort) {
      return
    }

    this.setState({
      searchTerm : searchTerm,
      searchStore : searchStore,
      searchCountry : searchCountry,
      searchCategory : searchCategory,
      searchSort : searchSort })
    this.sendRequest(searchTerm, searchStore, searchCountry, searchStock, searchCategory, searchSort);
  }

  sendRequest(searchTerm, searchStore, searchCountry, showNoStock, searchCategory, sortOption) {
    this.setState({
      isSearching: true
    })
    var search_url = serverLocation + "/products/search/" + encodeURIComponent(searchTerm)
    var self = this;
    var data = {
      searchStore : searchStore,
      searchCountry : searchCountry,
      showNoStock : showNoStock,
      searchCategory : searchCategory,
      sortOption : sortOption
    }
    search_url += ("?"+jQuery.param( data ));
    $.get(search_url, function (result) {
      this.setState({
        'productData': this.dedupeProductData(result.results),
        'suggestTerm': result.suggestTerm,
        'isSearching': false
      });
    }.bind(this));
  }

  dedupeProductData(data) {
    var dedupedProducts = [];
    var exitingProducs = {}
    data.forEach(function(product){
      if (!exitingProducs[product.title]) {
        exitingProducs[product.title] = product.store;
        dedupedProducts.push(product);
      }
    })

    return dedupedProducts;
  }

  productClick(link) {
    var search_url = serverLocation + "/products/click"
    ga('send', 'event', 'outbound', 'click', link, {
      'transport': 'beacon',
      'hitCallback': function(){
        console.log("sent ga")
        $.post(search_url, {'link':link}).done(function( data ) {
          console.log("saved click")
        });
      }
    });
  }

  render() {
    var siteStyle = {
      "background-color" : "black"
    }

    return (
      <div className="index" style={siteStyle}>
        <NavBarComponent searchHandler={this.setSearchTerm}/>
        <ResultsComponent products={this.state.productData} searchTerm={this.state.searchTerm} isSearching={this.state.isSearching} suggestTerm={this.state.suggestTerm} onClickProduct={this.productClick} />
        <FooterComponent/>
      </div>
    );
  }
}

AppComponent.defaultProps = {
};

export default AppComponent;



/** WEBPACK FOOTER **
 ** ./src/components/Main.js
 **/